import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { ButtonProps } from '@material-ui/core/Button/Button';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { MODALS } from 'src/models/ModalModel';
import { openModal } from 'src/redux/actions/modalActions';
import { ENTITIES } from 'src/models/QuerybuilderModel';
import { t } from 'src/lib/language';

interface OwnProps {
  isUser?: boolean,
}

type Props = OwnProps & ButtonProps;

const ViewInvoiceButton = (props: Props) => {
  const { disabled, isUser } = props;
  const dispatch = useAppDispatch();
  const lang = useSelector((state: Store) => state.language.language);

  const selections = useSelector(
    (state: Store) => state.selected[ENTITIES.invoices] || [],
  );
  const handleOpen = () => {
    dispatch(openModal({ modal: MODALS.viewInvoice, payload: { isUser } }));
  };

  return (
    <Tooltip
      title={t(lang, 'menus.show_invoice')}
      placement="top-start">
      <span>
        <ActionButton
          variant="outlined"
          category={MENU_BUTTON_CATEGORY.action}
          onClick={handleOpen}
          disabled={disabled || !selections.length}>
          <VisibilityIcon />
        </ActionButton>
      </span>
    </Tooltip>
  );
};

export default ViewInvoiceButton;
